import { takeLatest, all } from 'redux-saga/effects';
import { LiveDepartureTypes } from '../redux/LiveDeparture';
import {
  getFilteredRoutesNames, getDepartures, getMoreDepartures, storeFilteredRoutesNames,
} from './LiveDepartures/LiveDeparturesSaga';
import timetablesSaga from './TimetablesSaga';

export default function* root() {
  yield all([
    takeLatest(LiveDepartureTypes.GET_DEPARTURES, getDepartures),
    takeLatest(LiveDepartureTypes.GET_MORE_DEPARTURES, getMoreDepartures),
    takeLatest(LiveDepartureTypes.GET_FILTERED_ROUTES_NAMES, getFilteredRoutesNames),
    takeLatest(LiveDepartureTypes.STORE_FILTERED_ROUTES_NAMES, storeFilteredRoutesNames),
    ...timetablesSaga(),
  ]);
}
